import { PositionsScreenRow } from 'app/models/positions-screen-row'
import * as types from './types'

export const getPositionsScreen = (rows: PositionsScreenRow[]) => ({
  type: types.GET_POSITIONS_SCREEN,
  payload: rows,
})

export const startLoadingPositionsScreen = () => ({
  type: types.START_LOADING_POSITIONS_SCREEN,
  payload: null,
})

export const stopLoadingPositionsScreen = () => ({
  type: types.STOP_LOADING_POSITIONS_SCREEN,
  payload: null,
})
